import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AvatarNominativeComponent } from "./avatar-nominative.component";

@NgModule({
  imports: [CommonModule],
  declarations: [AvatarNominativeComponent],
  exports: [AvatarNominativeComponent]
})
export class AvatarNominativeModule {}
